export const Menu = ({view, setView}) => {

    function changeView(view) {
        setView(view);
    }

    return (
        <div>

            <nav className="slidemenu">

                <input type="radio" name="slideItem" id="slide-item-1" className="slide-toggle"
                       onClick={() => changeView("main")} checked={view === 'main'}/>
                <label htmlFor="slide-item-1">
                    <span>Home</span></label>

                <input type="radio" name="slideItem" id="slide-item-2" className="slide-toggle"
                       onClick={() => changeView("gallery")} checked={view === 'gallery'}/>
                <label htmlFor="slide-item-2">
                    <span>Gallery</span></label>

                <input type="radio" name="slideItem" id="slide-item-3" className="slide-toggle"
                       onClick={() => changeView("download")} checked={view === 'download'}/>
                <label htmlFor="slide-item-3">
                    <span>Downloads</span></label>

                <input type="radio" name="slideItem" id="slide-item-4" className="slide-toggle"
                       onClick={() => changeView("about")} checked={view === 'about'}/>
                <label htmlFor="slide-item-4">
                    <span>About</span></label>

                <div className="clear"></div>

                <div className="slider">
                    <div className="bar"></div>
                </div>

            </nav>

        </div>
    );
}
